'use client'
import { SelectCheckboxShowMore, SelectCheckboxShowMoreProps } from '@/shared/ui/checkbox'
import { SelectionDictionaryParams } from '../../api'
import { Skeleton } from '@/shared/ui/skeleton'
import { arrayValues } from '@/shared/lib/helpers/array'
import { dictionaryQueries } from '../../api'

interface ComponentProps extends Omit<SelectCheckboxShowMoreProps, 'defaultValues' | 'options'> {
  dictionary: SelectionDictionaryParams
  defaultValues?: SelectCheckboxShowMoreProps['defaultValues']
}

export default function Component(props: ComponentProps) {
  const { data, isLoading } = dictionaryQueries.useGet(props.dictionary)
  if (isLoading) {
    return arrayValues(props?.showMoreProps?.defaultVisibleItems || 3).map((v, i) => (
      <Skeleton key={i} className="w-full h-10" />
    ))
  }

  return (
    <SelectCheckboxShowMore
      idFieldName="id"
      valueFieldName="id"
      labelFieldName="name"
      checkboxProps={{
        labelProps: {
          className: 'border-none hover:bg-muted cursor-pointer text-sm',
        },
        className: 'rounded-sm',
      }}
      className="gap-1"
      {...props}
      defaultValues={props.defaultValues || []}
      options={data || []}
      showMoreProps={{
        loadItemsCount: 1000000,
        ...(props?.showMoreProps || {}),
      }}
    />
  )
}
